module.exports = __webpack_public_path__ + "media/assets/duplicate-cab6fafe138ab4fcca52d2ad8f7c5f73.svg";